import React from "react";
import "./MendixPage.css";
import MendixOverview from "./MendixOverview";
import BannerImage from "../../../assets/other_image/mendix.jpg";
import Letsgetintouch from "../../PLMImplementation/BusinessProcessAndChangeManagement/Letsgetintouch";
import Banner from "../SolutionBanner/Banner";
import FloatingContactUs from "../../floting_contact/FloatingContactUs";

const MendixPage = () => {
  return (
    <section className="Mendix-process">
              <Banner
        image={BannerImage} // Pass the image for this page
        heading="Mendix App 
        Solutions" // Pass the heading text for this page
      />
      <FloatingContactUs />
       
        <MendixOverview />
        <section style={{ background: "#f5f7fa" }}>
        <div className="benefits container">
          <h4 className="Mendix-page-heading">Unlock the Power :</h4>
          <h5 className="Mendix-subheading">
            Discover the Transformative Benefits of Mendix App 
            Solutions with NexTech!
          </h5>
          <ul className="custom-bullets">
            <li>Implement both Agile and DevOps best practices </li>
            <li>
              Involve business stakeholders in the actual development of the
              applications{" "}
            </li>
            <li>
              Offer both no-code and low-code tooling in one single fully
              integrated platform
            </li>
            <li>
              Cloud-native architecture and automation tools support the
              deployment, management, and monitoring of highly available
              enterprise-grade applications{" "}
            </li>
          </ul>
        </div>
        </section>
        <section>
        <div className="solutions container">
          <h4 className="Mendix-page-heading">Our Solutions</h4>
          <ul className="custom-bullets">
            <li>Active engagement of business stakeholders in the application development process. </li>
            <li>Provision of both no-code and low-code tooling within a single integrated platform. </li>
            <li>Utilization of cloud-native architecture and automation tools for enterprise-grade app deployment. </li>
            <li>Implementation of Agile and DevOps best practices for efficient app development. </li>
            <li>Enhancement of user experience through a responsive design and WCAG 2.1 accessibility support. </li>
          </ul>
        </div>
        </section>
        <section style={{ background: "#f5f7fa" }}>
        <div className="why-nextech container">
          <h4 className="Mendix-page-heading">Why NexTech?</h4>
          <h5 className="Mendix-subheading">
            For Mendix Solutions  
          </h5>
          <ul className="custom-bullets">
            <li>
            Nextech enables seamless implementation of Agile and DevOps methodologies for accelerated development cycles. 
            </li>
            <li>
            With Nextech, businesses can actively involve stakeholders in the development process, ensuring alignment with organizational objectives. 
            </li>
            <li>
            Nextech offers an integrated platform with both no-code and low-code tooling, simplifying development workflows and enhancing productivity. 
            </li>
            <li>
            Leveraging cloud-native architecture and automation tools, Nextech supports the deployment, management, and monitoring of robust enterprise-grade applications. 
            </li>
            <li>
            Nextech empowers developers with Mendix's key capabilities, including a built-in React Native framework for cross-platform mobile app development and collaboration tools for effective team communication and agile project management. 
            </li>
          </ul>
        </div>
        </section>
        <section>
        <div className="solutions container">
          <h4 className="Mendix-page-heading">Mendix Key Capabilities</h4>
          <ul className="custom-bullets">
            <li>Use low-code platform with a built-in React Native framework to create mobile applications specifically for iOS and Android </li>
            <li>Take it further with conversational and immersive experiences </li>
            <li>All built from a single platform, with no talent constraints. </li>
            <li>Ensure effective business-IT communication throughout the application lifecycle </li>
            <li>Built-in collaboration tools for team development, feedback management, and agile project management </li>
            <li>Perfect the user experience with an Atlas UI Framework to build a truly responsive design across devices Make it accessible with WCAG 2.1 levels A and AA support. </li>
          </ul>
        </div>

      </section>
      <Letsgetintouch />
    </section>
  );
};

export default MendixPage;
